import { render } from "./AppMenu.vue?vue&type=template&id=6a5c8629"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Sekou A Sidibe\\Documents\\NTA TECH\\projets\\backoffice_operation_mouton\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__